import { useEffect } from 'react';
import { initiatePostVisitId } from '../../pages/checkout/Checkout.state';

const usePostVisitId = (order, dispatch) =>
  useEffect(() => {
    // Create a visit ID via POST request if an order_id exists in state
    if (order?.order_id && dispatch) {
      dispatch(initiatePostVisitId({ order_id: order.order_id }));
    }
  }, [order?.order_id, dispatch]);

export default usePostVisitId;
